import { render, staticRenderFns } from "./PcSolveShow.vue?vue&type=template&id=88f511ce&scoped=true&"
import script from "./PcSolveShow.vue?vue&type=script&lang=js&"
export * from "./PcSolveShow.vue?vue&type=script&lang=js&"
import style0 from "./PcSolveShow.vue?vue&type=style&index=0&id=88f511ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f511ce",
  null
  
)

export default component.exports